import type { SVGProps } from 'react';
const SvgAddToQueue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#add_to_queue_svg__a)">
      <path
        fill="currentColor"
        d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2Zm0 14H3V5h18v12Zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3Z"
      />
    </g>
    <defs>
      <clipPath id="add_to_queue_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddToQueue;
